import { render, staticRenderFns } from "./BodyAnatomyBtns.vue?vue&type=template&id=c6acd87e&"
import script from "./BodyAnatomyBtns.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports